// extracted by mini-css-extract-plugin
export default {"confirm":"Confirm-module__confirm--n8VYS","copilotRun":"Confirm-module__copilotRun--zM4bk"};